const SubscriptionGetter = {
  subscription: s => s.subscription,
  subscription_payload: s => s.subscription_payload,
  subscription_cost: s => s.subscription_cost
};

export default SubscriptionGetter;
